export default __webpack_public_path__ + "static/media/bottom3 1.8ce2d9e1.png";